var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124 248C55.6242 248 0 192.373 0 124C0 55.6271 55.6242 0 124 0C192.376 0 248 55.6271 248 124C248 192.373 192.376 248 124 248Z",
    fill: "#D7EBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M248 124C248 55.6271 192.376 0 124 0V248C192.376 248 248 192.373 248 124Z",
    fill: "#C4E2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124 231.826C64.543 231.826 16.1738 183.455 16.1738 124C16.1738 64.5455 64.543 16.1738 124 16.1738C183.457 16.1738 231.826 64.5459 231.826 124C231.826 183.454 183.457 231.826 124 231.826Z",
    fill: "#88CC2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M231.826 124C231.826 64.5459 183.457 16.1738 124 16.1738V231.826C183.457 231.826 231.826 183.454 231.826 124Z",
    fill: "#7FB335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.217 172.522C109.079 172.522 104.941 170.942 101.782 167.783L68.4548 134.456C62.1366 128.141 62.1366 117.901 68.4548 111.585C74.773 105.267 85.0079 105.267 91.3261 111.585L113.217 133.474L159.37 87.3236C165.688 81.0054 175.923 81.0054 182.241 87.3236C188.559 93.6389 188.559 103.879 182.241 110.195L124.653 167.783C121.494 170.942 117.356 172.522 113.217 172.522Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159.37 87.3245L124 122.692V168.316C124.211 168.126 124.449 167.986 124.653 167.783L182.241 110.195C188.559 103.88 188.559 93.6398 182.241 87.324C175.923 81.0063 165.688 81.0063 159.37 87.3245Z",
    fill: "#EDF0F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.94cbafa1ade6d2ca4b26ddfbf4285390.svg";
export { ForwardRef as ReactComponent };